import { _login, _receive } from '@/api'
const map = {
  state: {
    systemMap: null,
    merchantKyc: null,
    areaList: null,
    routeRefresh: true,
    frontProVersion: ''
  },
  getters: {
    statusAll(state) {
      return state.systemMap || (localStorage.getItem('systemMap') ? JSON.parse(localStorage.getItem('systemMap')) : state.systemMap)
    },
    getAreaData(state) {
      return state.areaList || (localStorage.getItem('areaList') ? JSON.parse(localStorage.getItem('areaList')) : state.areaList)
    },
    getMerchantKyc(state) {
      return state.merchantKyc || (localStorage.getItem('merchantKyc') ? JSON.parse(localStorage.getItem('merchantKyc')) : state.merchantKyc)
    }
  },
  mutations: {
    setSystemMap (state, obj) {
      state.systemMap = obj
      localStorage.setItem('systemMap', JSON.stringify(obj))
    },
    setMerchantKyc (state, obj) {
      state.merchantKyc = obj
      localStorage.setItem('merchantKyc', JSON.stringify(obj))
    },
    setAreaList (state, obj) {
      state.areaList = obj
      localStorage.setItem('areaList', JSON.stringify(obj))
    },
    setFrontVersion (state, v) {
      state.frontProVersion = v
    }
  },
  actions: {
    async getLanguage({ commit }) {
      const res = await _login.getLanguage()
      if (res.data.succ) commit('setSystemMap', res.data.data)
    },
    async getAreaList({ commit }) {
      const res = await _receive.getAreaPub()
      if (res.data.succ) commit('setAreaList', res.data.data)
    }
  }
}

export default map
